module.exports = __webpack_public_path__ + "static/kids-f58334129657a282ba3ad5a530997890.png";